const getDirtyFields = <TData extends Record<keyof TDirtyItems, unknown>, TDirtyItems extends Record<string, unknown>>(
    data: TData,
    dirtyItems: TDirtyItems,
): Partial<TData> => {
    const dirtyItemsEntries = Object.entries(dirtyItems);

    return dirtyItemsEntries.reduce((dirtyData, [name, value]) => {
        if (typeof value !== 'object') {
            return { ...dirtyData, [name]: data[name] };
        }

        return {
            ...dirtyData,
            [name]: getDirtyFields(data[name] as TData, dirtyItems[name] as TDirtyItems),
        };
    }, {});
};

const pickTruthyFields = <TData extends Record<TPickedItems[number], unknown>, TPickedItems extends string[]>(
    obj: TData,
    pickKeys: TPickedItems,
) => {
    let hasTruthyFields = false;
    const truthyFields = Object.keys(obj)
        .filter(key => pickKeys.includes(key))
        .reduce((a, key) => {
            if (obj?.[key as keyof typeof obj] !== undefined || obj?.[key as keyof typeof obj] !== null) {
                hasTruthyFields = true;
                return {
                    ...a,
                    [key]: obj[key as keyof typeof obj],
                };
            }

            return a;
        }, {});

    return {
        truthyFields: truthyFields as Partial<TData>,
        hasTruthyFields,
    };
};

export { getDirtyFields, pickTruthyFields };
